import { render } from "./InputSingleSelect.vue?vue&type=template&id=a3facc80"
import script from "./InputSingleSelect.vue?vue&type=script&lang=ts"
export * from "./InputSingleSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script